// "Trending" for the Braindate carousel.
//
// Braindate exposes four engagement counters per topic (statistics.views_count,
// bookmarked_count, braindates_count, invitation_count) plus participants_count,
// spots_left and a reactions array. Verified against event 1903 on 2026-08-16:
// EVERY one of them is 0 before the event goes live, except views_count (0-2
// across 9 topics) and a single topic with one signup. So this scores on signals
// that are empty today and fill up later — which is why the tie-break matters as
// much as the weights.
//
// Weighting reflects how much commitment each signal represents:
//   booking a braindate  > joining a topic > bookmarking > reacting > viewing
// A view is one click and the noisiest of the five; a booking is someone
// putting time in their calendar.
const WEIGHTS = {
    braindatesCount: 8,
    signups: 5,
    bookmarkedCount: 3,
    reactionsCount: 2,
    viewsCount: 1,
};

const num = (value) => (Number.isFinite(value) ? value : 0);

export const trendingScore = (braindate) => {
    if (!braindate) return 0;
    return Object.entries(WEIGHTS)
        .reduce((total, [key, weight]) => total + num(braindate[key]) * weight, 0);
};

const startMs = (b) => {
    const t = new Date(b?.startDateTime).getTime();
    return Number.isNaN(t) ? Infinity : t;
};

// Highest score first, soonest start as the tie-break. Before the event has any
// engagement every score is 0, so this collapses to plain chronological order —
// the block looks exactly as it does today and starts ranking on its own once
// people begin booking, with no switch to flip.
export const sortByTrending = (braindates) => [...(braindates || [])].sort((a, b) => {
    const diff = trendingScore(b) - trendingScore(a);
    if (diff !== 0) return diff;
    return startMs(a) - startMs(b);
});
